import React, { useContext } from "react";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import chRobinsonLogo from "../../../../assets/images/chrobinson/chrobinson-logo.jpeg";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import { useFormik } from "formik";
import ISupplier_Integration from "../../../../models/ISupplier_Integration";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";

type Props = {
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const ChRobinsonConnect = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const toggleIntegration = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_chrobinson: !supplierModel.Supplier_Integration.has_chrobinson,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const disconnect = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_chrobinson: false,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const saveIntegrationValues = (values: Partial<ISupplier_Integration>) => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                chrobinson_client_id: values.chrobinson_client_id || "",
                chrobinson_customer_code: values.chrobinson_customer_code || "",
            },
        };

        if (values.chrobinson_client_secret?.length) {
            payload.Supplier_Integration.chrobinson_client_secret = values.chrobinson_client_secret;
        }

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const formik = useFormik({
        initialValues: {
            chrobinson_client_id: supplierModel.Supplier_Integration.chrobinson_client_id,
            chrobinson_client_secret: "",
            chrobinson_customer_code: supplierModel.Supplier_Integration.chrobinson_customer_code,
        },
        onSubmit: (values) => {
            saveIntegrationValues(values);
        },
    });

    return (
        <div className={"ChRobinsonConnect"}>
            <OwAccordion
                hideChevron={!supplierModel.Supplier_Integration.has_chrobinson}
                leftImage={chRobinsonLogo}
                leftImageHeight={45}
                rightElem={
                    <div className={"ms-auto"}>
                        <OwToggle
                            fn={toggleIntegration}
                            name={"has_chrobinson"}
                            label={""}
                            active={!!supplierModel.Supplier_Integration.has_chrobinson}
                        />
                    </div>
                }>
                <div>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div>
                                <OwLabel title={"client_id"} />
                            </div>
                            <div>
                                <OwFnInput
                                    fn={formik.handleChange}
                                    name={"chrobinson_client_id"}
                                    value={formik.values.chrobinson_client_id}
                                />
                            </div>
                        </div>

                        <div className={"mt-2"}>
                            <div>
                                <OwLabel title={"client_secret"} />{" "}
                                {supplierModel.Supplier_Integration.chrobinson_client_secret?.length ? (
                                    <span className={"text-success ms-4"}>
                                        <i className={"fas fa-check"} /> Secret Set
                                    </span>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                <OwFnInput
                                    fn={formik.handleChange}
                                    name={"chrobinson_client_secret"}
                                    value={formik.values.chrobinson_client_secret}
                                />
                            </div>
                        </div>

                        <div className={"mt-2"}>
                            <div>
                                <OwLabel title={"customer_code"} />
                            </div>
                            <div>
                                <OwFnInput
                                    fn={formik.handleChange}
                                    name={"chrobinson_customer_code"}
                                    value={formik.values.chrobinson_customer_code}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwButton title={"save"} type={"submit"} />
                        </div>
                    </form>
                </div>
            </OwAccordion>
        </div>
    );
};
